import { effectivePricingPlan } from '../../lib/effectivePricingPlan'
import { Banner, Button, Card, DataTable, Icon, Link, Pagination, Spinner, Stack, TextStyle, Tooltip } from '@shopify/polaris'
import { CircleAlertMajor } from '@shopify/polaris-icons'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import StatusTestAb from '../../components/StatusTestAb/StatusTestAb'
import useCustomHistory from '../../hooks/useCustomHistory'
import { useTestsAB } from './hooks'
import './style.scss'
import moment from 'moment'
import ItemMenu from './components/ItemMenu/ItemMenu'
import DashboardFilter from './components/DashboardFilter/DashboardFilter'
import BulkProductListTooltip from '../../components/Fields/BulkProductListTooltip'
import DashboardHelper from '../../lib/DashboardHelper'
import { InfoMinor } from '@shopify/polaris-icons'
import ContentItemMenu from './components/ContentItemMenu/ContentItemMenu'
import UpsellModal from '../../components/Upsell/UpsellModal'
import { useChangePlan } from '../Pricing/hooks'
import PauseFinishModal from './components/PauseFinishModal/PauseFinishModal'
import CustomToast from '../../components/CustomToast/CustomToast'
import PixelSetupWarning from './components/PixelSetupWarning/PixelSetupWarning'
import FreeTrialBanner from '../../components/FreeTrialNotifications/FreeTrialBanner'
import FreeTrialModal from '../../components/FreeTrialNotifications/FreeTrialModal'
import { isExpired } from '../../components/FreeTrialNotifications/helper'

const getImageProduct = (test) => {

  if (test.parent_on_bulk) {
    if (test.childrenTests[0]) {
      if (test.childrenTests[0].sample_image || null) {
        return test.childrenTests[0].sample_image
      } else {
        return '/logo192.png'
      }
    }
  }
  if (test.test_a) {
    if (test.test_a.images) {
      if (test.test_a.images.length) {
        return test.test_a.images[0].s3_src || test.test_a.images[0].src
      }
    }
  }

  return '/logo192.png'
}

function formatTimestamp(timestamp) {
  const date = new Date(timestamp)
  const formattedDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
  return formattedDate
}

function Dashboard({ shop, showToast, setShowToast, message, setMessage }) {
  const [page, setPage] = useState(1)
  const [trialExpired, setTrialExpired] = useState(null)
  const history = useCustomHistory()
  const [
    { total, list, searchParam, loaded, statusParam, sortParams, appExtension, showUpsell },
    { getTests, setSearchParam, setStatusParam, deleteTest, setSortParams, setShowUpsell, winnerTest, pauseTest, resumeTest, resumeTestWithPlanCheck, resumeBulkTestWithPlanCheck, resumeBulkTest, deleteBulkTest, deleteContentTest, changeContentTestStatus, pauseBulkTest, finishBulkTest }
  ] = useTestsAB()

  const [changePlan] = useChangePlan()

  const dispatch = useDispatch()

  const columns = ['name', 'product_title', 'status', 'createdAt', 'time', 'type']

  useEffect(() => {
    setTrialExpired(isExpired(shop))
  }, [shop])

  useEffect(() => {
    getTests(page, searchParam || '', sortParams, statusParam || [])
    dispatch({
      type: 'SET_TEST_AB', data: {
        start_date: moment().toDate(),
        finish_date: moment().add(14, 'days').toDate(),
        variant_every: 30,
        variant_every_type: 'minutes',
        automatically_set_winner: false,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  function bulkOrProductTitle(test) {

    if (isBulkParent(test)) {
      return (<div style={{ display: 'flex', gap: '5px' }}> {test.childrenCount ?? test.childrenTests.length} Products <BulkProductListTooltip testAB={test} />
      </div>)
    }
    if (isProductAttribute(test)) return test.test_a.title.length > 20 ? `${test.test_a.title.substring(0, 20)}...` : test.test_a.title
    if (isContentTest(test)) return 'Content Test'
  }

  const rows = list.map(test => (
    [
      <div className="productName">
        <div className="img">
          <img src={getImageProduct(test)} alt="" />
        </div>
        <Tooltip content={test.name}>
          <TextStyle>
            {test.name.length > 15 ? `${test.name.substring(0, 15)}...` : test.name}
          </TextStyle>
        </Tooltip>
      </div>,
      <div className="block">
        {bulkOrProductTitle(test)}
      </div>,
      <div className="block">
        <StatusTestAb test={test} />
      </div>,
      <div className="block">
        {formatTimestamp(test.createdAt)}
      </div>,
      <div className="block">
        {DashboardHelper.getTime(test.time, test.status)}
      </div>,
      <div className="block">
        {test.type}
      </div>,
      <div className="actions">
        {isContentTest(test) && <Link removeUnderline onClick={() => { history.push(`/content-test/${test._id}/editor`) }}>Editor</Link>}
        <Link removeUnderline onClick={() => { history.push(viewResultsUrl(test)) }}>View results</Link>
        {renderItemMenus(test)}
      </div>,
    ]
  ))

  const handleSort = useCallback(
    (index, direction) => {
      const newSortParams = {
        field: columns[index],
        order: (direction === 'descending' ? 'desc' : 'asc')
      }
      setSortParams(newSortParams)
      if (page !== 1) setPage(1)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page],
  )

  const resumeWithRedirect = (redirectTo, planName) => {
    if (redirectTo === 'upgrade') {
      changePlan(planName)
    } else {
      history.push('/pricing')
    }
  }

  // if (!list.length) return <NoTests history={history}/>

  return (
    <div className="Dashboard">
      <PixelSetupWarning />
      <div style={{ marginBottom: '20px', textAlign: 'right' }}>
        <Button primary onClick={() => history.push('/welcome')}>Create Test</Button>
      </div>
      <FreeTrialBanner trialExpired={trialExpired} setTrialExpired={setTrialExpired}/>
      <FreeTrialModal trialExpired={trialExpired} setTrialExpired={setTrialExpired}/>
      <UpsellModal
        active={showUpsell}
        setActive={setShowUpsell}
        action={resumeWithRedirect}
      />
      <FreeLimitaionWarning shop={shop} history={history} />
      <AppExtensionWarning appExtension={appExtension} shop={shop} />
      <Card>
        <Card.Section>
          <DashboardFilter
            status={statusParam}
            setStatus={setStatusParam}
            search={searchParam}
            setSearch={setSearchParam}
            setPage={setPage}
          />
        </Card.Section>
        <PauseFinishModal variant={'set_winner'} updateTest={winnerTest} hideAcivator setShowToast={setShowToast} setMessage={setMessage}/>
        <PauseFinishModal variant={'pause'} updateTest={pauseTest} hideAcivator setShowToast={setShowToast} setMessage={setMessage}/>
        <div>
          <div
            style={{
              display: loaded ? 'none' : 'flex',
              justifyContent: 'center',
              padding: '20px 0'
            }}
          >
            <Spinner />
          </div>
          <div style={{ display: loaded ? 'block' : 'none' }}>
            <DataTable
              columnContentTypes={[
                'text',
                'text',
                'text',
                'text',
                'text',
                'text',
                'text',
              ]}
              headings={[
                'Name',
                'Product',
                'Status',
                'Created date',
                'Time',
                'Type',
                '',
              ]}
              rows={rows}
              sortable={[true, true, true, true, true, true, false]}
              defaultSortDirection={sortParams.order === 'desc' ? 'descending' : 'ascending'}
              initialSortColumnIndex={columns.indexOf(sortParams.field) !== -1 ? columns.indexOf(sortParams.field) : 3}
              onSort={handleSort}
            />
            <Stack distribution="center">
              <Pagination
                label={`${page} of ${Math.ceil(total / 5)}`}
                hasPrevious={page !== 1}
                onPrevious={() => setPage(page - 1)}
                hasNext={page < Math.ceil(total / 5)}
                onNext={() => setPage(page + 1)}
              />
            </Stack>
            <div style={{ height: '.5rem' }}></div>
          </div>
        </div>
      </Card>
      <CustomToast message={message} active={showToast} setActive={setShowToast}/>
    </div>
  )

  function renderItemMenus(test) {
    if (test.parent_on_bulk) {
      return (
        <ItemMenu status={test.status} id={test._id} testAB={test} deleteTest={deleteBulkTest} resumeTest={resumeBulkTest} pauseBulkTest={pauseBulkTest} finishBulkTest={finishBulkTest} resumeTestWithPlanCheck={resumeBulkTestWithPlanCheck} setShowToast={setShowToast} setMessage={setMessage}/>
      )
    } else if (test.testType === 'content') {
      return (
        <ContentItemMenu list={list} contentTest={test} deleteContentTest={deleteContentTest} changeContentTestStatus={changeContentTestStatus} setShowToast={setShowToast} setMessage={setMessage}/>
      )
    }
    else {
      return (
        <ItemMenu status={test.status} id={test._id} testAB={test} deleteTest={deleteTest} resumeTest={resumeTest} resumeTestWithPlanCheck={resumeTestWithPlanCheck} setShowToast={setShowToast} setMessage={setMessage}/>
      )
    }
  }

  function viewResultsUrl(test) {
    if (isBulkParent(test)) return `/bulk_details/${test._id}`
    if (isProductAttribute(test)) return `/details/${test._id}`
    if (isContentTest(test)) return `/content-test/${test._id}/results`
  }

  function isBulkParent(test) {
    return test.testType === 'bulk_parent'
  }

  function isProductAttribute(test) {
    return test.testType === 'product_attribute'
  }

  function isContentTest(test) {
    return test.testType === 'content'
  }
}

function FreeLimitaionWarning({ shop, history }) {
  if (effectivePricingPlan(shop) === 'Free')
    return (
      <div className="FreeLimitaionWarning">
        <Banner
          status="info"
          action={{
            content: 'Upgrade to premium',
            onAction: () => { history.push('/pricing') },
            external: false
          }}
          title="Free plan limitations">
          You are currently on our Free plan and are only able to run a single test concurrently. Upgrade your TridentAB plan now to run more tests.
        </Banner>
      </div>
    )
  return <></>

}

function AppExtensionWarning({ appExtension, shop }) {
  if (!appExtension) return <></>
  if (appExtension.loaded) return <></>

  // if (true) return <></>

  return (
    <div className="AppExtensionWarning">
      <Banner
        icon={CircleAlertMajor}
        status="warning"
        action={{
          content: 'Continue',
          url: `https://${shop.shopify_domain}/admin/themes/current/editor?context=apps&uuid=${appExtension.uuid}`,
          external: true
        }}
        secondaryAction={{
          content: <LearnMore />,
          url: 'https://tridentab.zendesk.com/hc/en-us/articles/14052047402263',
          external: true
        }}
        title="You need to enable our TridentAB App Extension">
        TridentAB requires an App Extension to be enabled on your Online Store in order to work correctly. Click the “Continue” button below and enable the TridentAB App Extension to continue.
      </Banner>
    </div>
  )
}

function LearnMore() {
  return (
    <div className="LearnMore">
      <span className="text">Learn more</span>
      <div className="tooltip"><Icon source={InfoMinor} color="base" />
        <span className="tooltiptext"><LearnMoreToolTip /></span>
      </div>
    </div>
  )
}

function LearnMoreToolTip() {
  return (
    <div className="LearnMoreToolTip">
      Need more guidance? <span className="guide-link" data-url="https://www.loom.com/share/490d26dfe17b4a25973dead4e2968c65">Click here</span> to see a <span className="guide-link" data-url="https://www.loom.com/share/490d26dfe17b4a25973dead4e2968c65">step-by-step video guide</span> on how to do this.
    </div>
  )
}

export default Dashboard
